import { Injectable } from '@angular/core';
import { AppSettingsService } from '@services/settings';
import { Observable, from, throwError } from 'rxjs';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { IDocumentItem } from '../../interfaces/IDocumentItem';
import { DocumentsProxyService } from '../documents-proxy/documents-proxy.service';

@Injectable()
export class DocumentsService {
  private baseUrl: string;

  private _ready = false;
  private getBaseUrl: Observable<void>;

  constructor(private documentProxyService: DocumentsProxyService, private appSettings: AppSettingsService) {
    this.getBaseUrl = from(this.appSettings.apiBaseUrl()).pipe(
      map(baseUrl => {
        this.baseUrl = baseUrl;
        this._ready = true;
      })
    );
  }

  getDocuments(): Observable<IDocumentItem[]> {
    const commError = !this._ready;
    const getDocuments = !this._ready
      ? this.getBaseUrl.pipe(concatMap(() => this.documentProxyService.getDocuments()))
      : this.documentProxyService.getDocuments();

    return getDocuments.pipe(
      tap(documentItems => this.updateUrl(documentItems)),
      catchError(e => this.handleError(commError, e))
    );
  }

  private updateUrl(documentItems: IDocumentItem[]) {
    documentItems.forEach(documentItem => {
      if (documentItem.url) {
        documentItem.url = this.baseUrl + documentItem.url;
      } else if (documentItem.children) {
        this.updateUrl(documentItem.children);
      }
    });
  }

  private handleError(communicationError: boolean, error: any): Observable<never> {
    const e = error;
    if (communicationError) {
      error = {
        error: this.getErrorMessage(e),
        message: e.message,
        type: 'Mobile.ServerError'
      };
    }

    return throwError(error);
  }

  private getErrorMessage(error): string {
    switch (error.status) {
      case 404:
        return 'Not found';
      case 500:
        return 'Internal server error';
    }
  }
}
